/// <reference path="../../App/plugins/DefinitelyTyped/bootstrap-select.d.ts"/>

import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/TaskGroup/taskGroup.html'
})

export class TaskGroupComponent implements OnInit {
    public Constants: Constants;
    public taskDetails: any = [];
    public taskGroupList: any = [];
    public addTaskData: any = { addProjectTypeId: "", addTaskId: "" };
    public editTaskData: any = {};
    public addNewTask: any = {};
    public filterProjectTypeId: any = [];
    public taskDropdown: any = [];
    public active = true;
    public isAdd: boolean = true;
    public isUpdate: boolean = false;
    public userDetail: any;
    public showLoader = false;
    public existsValue: boolean = false;
    public isFormSubmitted: boolean = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.Constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    }

    ngOnInit() {
        this.gettaskDetails();
        this.getProjectTypeList();
        this.getTaskDropdown();
        this.projectTab();
    }

    ngAfterViewInit() {
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
        setTimeout(() =>
            $('.TaskGroup').selectpicker()
            , 1000);
    }

    public AddTaskTypeMappingLoad() {
        $('#btnAddTaskTypeMappingForm').trigger('click');
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }

    public gettaskDetails() {
        this.showLoader = true;
        this._httpService.ajaxPost('TaskGroup/GetTaskGroup', { "ProjectTaskGroupId": 0, "Project_Type": this.filterProjectTypeId }).subscribe(
            data => {
                this.taskDetails = data["taskInfo"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.Constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getTaskDropdown() {
        this.showLoader = true;
        this._httpService.ajaxPost('TaskGroup/GetTaskList').subscribe(
            data => {
                this.taskDropdown = data["taskList"];
                $(".TaskGroup").selectpicker('refresh');
            }, err => {

                this.showLoader = false;
                this._sharedService.ShowMessage(this.Constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getProjectTypeList() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.Constants.enumParamterTypeName["ProjectType"] }).subscribe(
            data => {
                this.taskGroupList = data["Parameter"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    ExportItems() {
        ExportToExcel(this.taskDetails, "TaskGroup Details",
            ["ProjectTypeName", "TaskGroupName"],
            ["Project Type", "Task Group"]);
    }

    public clearFilter() {
        this.filterProjectTypeId = "";
        this.gettaskDetails();
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
        setTimeout(() =>
            $('.TaskGroup').selectpicker()
            , 1000);
    }

    public CancelAddTask() {
        this.existsValue = false;
        this.addTaskData = { addProjectTypeId: "", addTaskId: "" };
        this.newForm();
        $('#addTask').modal('hide');
        this.isAdd = true;
    }

    public CancelEditTask() {
        this.existsValue = false;
        this.newForm();
        $('#editTask').modal('hide');
        this.isAdd = true;
    }

    public cancelAddTaskGroup() {
        this.isFormSubmitted = false;
        this.addNewTask = {};
        this.existsValue = false;
    }

    public cancelEditTaskGroup(item: any) {
        this.isFormSubmitted = false;
        this.isUpdate = false;
        this.existsValue = false;
        this.addNewTask = {};
    }

    public newTask(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsValue = false;
            this.taskDropdown.forEach(element => {
                if (element.TaskGroupName.trim().toLowerCase() == this.addNewTask.addNewTaskname.trim().toLowerCase()) {
                    this.existsValue = true;
                }
            });
            if (!this.existsValue) {
                let objItem: any = {};
                objItem.TaskGroupName = this.addNewTask.addNewTaskname;
                objItem.TaskGroupId = 0,
                    objItem.ModifiedBy = this.userDetail.SiteUserId,
                    objItem.CreatedBy = this.userDetail.SiteUserId,
                    this.addEditTaskGroup(objItem, form);
                this.addNewTask = {};
                this.isAdd = true;
            }
        }
    }

    public editTaskGroup(item: any) {
        this.isUpdate = true;
        this.addNewTask.addNewTaskname = item.TaskGroupName;
        this.addNewTask.addNewTaskId = item.TaskGroupId;
    }

    public updateTaskGroup(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsValue = false;
            this.taskDropdown.forEach(element => {
                if (element.TaskGroupId != this.addNewTask.addNewTaskId && element.TaskGroupName.trim().toLowerCase() == this.addNewTask.addNewTaskname.trim().toLowerCase()) {
                    this.existsValue = true;
                }
            });
            if (!this.existsValue) {
                let objItem: any = {};
                objItem.TaskGroupName = this.addNewTask.addNewTaskname;
                objItem.TaskGroupId = this.addNewTask.addNewTaskId;
                objItem.ModifiedBy = this.userDetail.SiteUserId;
                objItem.CreatedBy = 0;
                this.addEditTaskGroup(objItem, form);
                this.addNewTask = {};
                this.isAdd = true;
            }
        }
    }

    public Addtask(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsValue = false;
            this.taskDetails.forEach(element => {
                if (element.Project_Type == this.addTaskData.addProjectTypeId && element.TaskGroupId == this.addTaskData.addTaskId) {
                    this.existsValue = true;
                }
            });
            if (!this.existsValue) {
                let objItem: any = {};
                objItem.ProjectTaskGroupId = 0;
                objItem.TaskGroupId = this.addTaskData.addTaskId;
                objItem.Project_Type = this.addTaskData.addProjectTypeId;
                objItem.CreatedBy = this.userDetail.SiteUserId;
                objItem.ModifiedBy = this.userDetail.SiteUserId;
                this.addEditTask(objItem);
                this.isFormSubmitted = false;
                $('#addTask').modal('hide');
                this.addTaskData = { addProjectTypeId: "", addTaskId: "" };
                this.newForm();
                this.isAdd = true;
            }
        }
    }

    public EditTask(item: any) {
        $('#btnEditTaskTypeMappingForm').trigger('click');
        this.active = false;
        setTimeout(() => this.active = true, 0);
        setTimeout(() =>
            $('.TaskGroup').selectpicker()
            , 500);
        this.EditTaskChange(item.ProjectTaskGroupId);
    }

    public EditTaskChange(itemId) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.taskDetails.filter((taskInfo) => taskInfo.ProjectTaskGroupId == itemId)[0]));
        this.editTaskData.editProjectTypeId = objItem.Project_Type;
        this.editTaskData.ProjectTaskGroupId = objItem.ProjectTaskGroupId;
        this.editTaskData.editTaskId = objItem.TaskGroupId;
    }

    public updateTask(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsValue = false;
            this.taskDetails.forEach(element => {
                if (element.ProjectTaskGroupId != this.editTaskData.ProjectTaskGroupId && element.Project_Type == this.editTaskData.editProjectTypeId && element.TaskGroupId == this.editTaskData.editTaskId) {
                    this.existsValue = true;
                }
            });

            if (!this.existsValue) {
                let objItem: any = {};
                objItem.Project_Type = this.editTaskData.editProjectTypeId;
                objItem.ProjectTaskGroupId = this.editTaskData.ProjectTaskGroupId;
                objItem.TaskGroupId = this.editTaskData.editTaskId;
                objItem.CreatedBy = this.userDetail.SiteUserId;
                objItem.ModifiedBy = this.userDetail.SiteUserId;
                this.addEditTask(objItem);
                $('#editTask').modal('hide');
                this.editTaskData = {};
                this.isAdd = true;
            }
        }
    }

    addEditTask(objItem) {
        this.showLoader = true;
        this._httpService.ajaxPost('TaskGroup/AddUpdateTask', objItem).subscribe(
            data => {
                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                this.gettaskDetails();
            }, err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    addEditTaskGroup(objItem, form: any) {
        this.showLoader = true;
        this._httpService.ajaxPost('TaskGroup/AddUpdateTaskGroup', objItem).subscribe(
            data => {
                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                this.isFormSubmitted = false;
                form.reset();
                form.resetForm();

                this.getTaskDropdown();
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );

    }

    projectTab() {
        this.getTaskDropdown();
        this.gettaskDetails();
    }
}




/** WEBPACK FOOTER **
 ** ./TypeScripts/TaskGroup/taskGroup.component.ts
 **/